import Inicio from "./inicio";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { setDadosAction, getDadosFormularioAction } from "../../store/kyc/actions";

const mapStateToProps = (state, nextState) => ({
  formulario: state.formularioReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ setDadosAction, getDadosFormularioAction }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Inicio);
